import Image from 'next/image';

type AtmosphereVariant = 'public' | 'auth' | 'dashboard';

interface ExperienceAtmosphereProps {
    variant?: AtmosphereVariant;
    priority?: boolean;
}

export default function ExperienceAtmosphere({ variant = 'public', priority = false }: ExperienceAtmosphereProps) {
    return (
        <div className={`experience-atmosphere experience-atmosphere--${variant}`} aria-hidden="true">
            <Image
                src="/assets/experience/cosmic-field.webp"
                alt=""
                fill
                priority={priority}
                sizes="100vw"
                className="experience-atmosphere__image"
            />
            <div className="experience-atmosphere__veil" />
        </div>
    );
}
